// extracted by mini-css-extract-plugin
module.exports = {"root":"CubesList-module__root__2vZ43"};